/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DeviceConfigurationAndSchema } from "./DeviceConfigurationAndSchema";
import {
    DeviceConfigurationAndSchemaFromJSON,
    DeviceConfigurationAndSchemaFromJSONTyped,
    DeviceConfigurationAndSchemaToJSON,
} from "./DeviceConfigurationAndSchema";

/**
 *
 * @export
 * @interface DeviceConfigurationResponse
 */
export interface DeviceConfigurationResponse {
    /**
     *
     * @type {Array<DeviceConfigurationAndSchema>}
     * @memberof DeviceConfigurationResponse
     */
    items?: Array<DeviceConfigurationAndSchema>;
    /**
     * Map of Categories (eg electrical, electricalSolarOnly) to list of config keys in that category
     * @type {{ [key: string]: Array<string>; }}
     * @memberof DeviceConfigurationResponse
     */
    categoriesToKeys?: { [key: string]: Array<string> };
}

/**
 * Check if a given object implements the DeviceConfigurationResponse interface.
 */
export function instanceOfDeviceConfigurationResponse(
    value: object,
): value is DeviceConfigurationResponse {
    return true;
}

export function DeviceConfigurationResponseFromJSON(
    json: any,
): DeviceConfigurationResponse {
    return DeviceConfigurationResponseFromJSONTyped(json, false);
}

export function DeviceConfigurationResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceConfigurationResponse {
    if (json == null) {
        return json;
    }
    return {
        items:
            json["items"] == null
                ? undefined
                : (json["items"] as Array<any>).map(
                      DeviceConfigurationAndSchemaFromJSON,
                  ),
        categoriesToKeys:
            json["categoriesToKeys"] == null
                ? undefined
                : json["categoriesToKeys"],
    };
}

export function DeviceConfigurationResponseToJSON(
    value?: DeviceConfigurationResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        items:
            value["items"] == null
                ? undefined
                : (value["items"] as Array<any>).map(
                      DeviceConfigurationAndSchemaToJSON,
                  ),
        categoriesToKeys: value["categoriesToKeys"],
    };
}
